import AIEntityInstructionDTO from '../aiEntityInstructionDTO';

export class CopilotExternalDocumentInstructionEditRequestDTO {
  externalId?: string;
}

export class CopilotExternalDocumentInstructionEditDTO {
  externalId?: string;

  libraryLinkId?: number;

  libraryListId?: number;

  title?: string;

  pendingInstruction?: string;

  instruction?: AIEntityInstructionDTO;
}
